// extracted by mini-css-extract-plugin
module.exports = {"freePriceTextWrap":"UplinkNoteModal_freePriceTextWrap__1xdvZ","freePriceText":"UplinkNoteModal_freePriceText__2k_FJ","button":"UplinkNoteModal_button__1M44A"};